import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
} from '@angular/common/http';
import { SessionService } from '../services/session.service';

@Injectable()
export class IsValidateSession implements HttpInterceptor {
  constructor() { }
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.includes(environment.SERVICES.VALIDATE_SESSION.URI)) {
      const accessToken = document.cookie.split('; ').find((row) => row.startsWith('accessToken=')).split('=')[1];
      req = req.clone({
        headers: req.headers.set('authorization', `Bearer ${accessToken}`)
      });
    }
    return next.handle(req);
  }
}
